import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    checkContent: {
      hosted:
        'It must indicate the first name, surname, address of your host and must be **less than 3 months old**.',
      selfHosted:
        'It must indicate your surname, first name, address and must be **less than 3 months old**.',
    },
    checkContentWithoutDate: {
      hosted: 'It must indicate the first name, surname, address of your host.',
      selfHosted: 'It must indicate your surname, first name, address.',
    },
    checkOrigin: {
      ELECTRICITY:
        'For any invoice or certificate, it must come from a major supplier (EDF, Engie, Veolia, etc.)',
    },
    checkQuality: {
      ELECTRICITY: {
        hosted:
          'The document should be readable in PDF format if possible and be granted by your host’s provider.',
        selfHosted:
          'The document must be readable and intelligible. We recommend the PDF format.',
      },

      INCOME_TAX_NOTICE: {
        hosted: 'The document must be readable and intelligible.',
        selfHosted: 'The document must be readable and intelligible.',
      },
      INTERNET: {
        hosted:
          'The document should be readable in PDF format if possible and be granted by your host’s provider.',
        selfHosted:
          'The document must be readable and intelligible. We recommend the PDF format.',
      },
      LANDLINE: {
        hosted:
          'The document should be readable in PDF format if possible and be granted by your host’s provider.',
        selfHosted:
          'The document must be readable and intelligible. We recommend the PDF format.',
      },
    },
    checkType: {
      ELECTRICITY:
        'It may be an invoice or a certificate of water, electricity, gas contract or a non-handwritten rent receipt.',
    },

    helpLink: 'How do I obtain this document?',
    residenceTax: 'Upload a residence tax',
    subtitle:
      'This may be your 2022 tax assessment or your 2022 residence tax notice (must be less than 3 months old)',
    title: {
      ELECTRICITY: 'Upload a utilities bill',
      GAZ_OR_WATER_BILL: 'Upload a gaz or water bill',
      INCOME_TAX_NOTICE: 'Upload an income tax notice',
      INTERNET: 'Upload an internet bill',
      LANDLINE: 'Upload a landline bill',
    },
  },
  fr: {
    checkContent: {
      hosted:
        'Elle doit contenir le prénom, le nom, l’adresse de votre hébergeur et dater de **moins de 3 mois**.',
      selfHosted:
        'Elle doit contenir votre nom, votre prénom, votre adresse et dater de **moins de 3 mois**.',
    },
    checkContentWithoutDate: {
      hosted:
        'Elle doit contenir **le prénom, le nom, l’adresse** de votre hébergeur.',
      selfHosted:
        'Elle doit contenir **votre nom, votre prénom, votre adresse**.',
    },
    checkOrigin: {
      ELECTRICITY:
        'Si facture ou attestation, elle doit provenir d’un fournisseur majeur (EDF, Engie, Veolia...).',
    },
    checkQuality: {
      ELECTRICITY: {
        hosted:
          'Le document doit être lisible, au format PDF si possible et provenir du fournisseur de votre hébergeur.',
        selfHosted:
          'Le document doit être lisible au format PDF et provenir de votre fourniseur.',
      },
      INCOME_TAX_NOTICE: {
        hosted: 'Le document doit être lisible au format PDF.',
        selfHosted: 'Le document doit être lisible au format PDF.',
      },
      INTERNET: {
        hosted:
          'Le document doit être lisible, au format PDF si possible et provenir du fournisseur de votre hébergeur.',
        selfHosted:
          'Le document doit être lisible au format PDF et provenir de votre fourniseur.',
      },
      LANDLINE: {
        hosted:
          'Le document doit être lisible, au format PDF si possible et provenir du fournisseur de votre hébergeur.',
        selfHosted:
          'Le document doit être lisible au format PDF et provenir de votre fourniseur.',
      },
    },
    checkType: {
      ELECTRICITY:
        'Elle peut-être une facture ou une attestation de contrat  d’eau, d’électricité, de gaz ou une quittance de loyer non manuscrite.',
    },

    helpLink: 'Comment obtenir ce document\u00A0?',
    residenceTax: 'Ajouter une taxe d’habitation',
    subtitle:
      'Cela peut-être un avis d’imposition 2022 ou la taxe d’habitation 2022 (qui doit être de moins de 3 mois)',
    title: {
      ELECTRICITY: 'Ajouter une facture de charges',
      GAZ_OR_WATER_BILL: 'Ajouter une facture d’eau ou de gaz',
      INCOME_TAX_NOTICE: 'Ajouter un avis d’imposition',
      INTERNET: 'Ajouter une facture internet',
      LANDLINE: 'Ajouter une facture de téléphone fixe',
    },
  },
});

export default locales;
